import { ComponentF } from "../ui";
import { handleKeyOnClick } from "./keyOnClick";

export const CharButton: ComponentF<{
  disabled?: boolean;
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C, props) => {
  const [state, setState] = C.useState({ hover: false });
  C.display.draw(
    C.bounds.x,
    C.bounds.y,
    props.title,
    props.disabled ? "#555555" : state.hover ? "#FFFFFF" : "#AAAAAA",
    null
  );

  if (!props.disabled) {
    C.handlers.hover = () => {
      setState({ hover: true });
    };

    C.handlers.out = () => {
      setState({ hover: false });
    };

    C.handlers.press = () => {
      props.onClick();
    };
  }

  handleKeyOnClick(C, props);
};
